import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Viewer from 'v-viewer'
import vClickOutside from 'v-click-outside'

import SvgIcon from '@/components/SvgIcon/index'
import Directives from './directives'

import '@/assets/font/iconfont.js'

import '@/assets/font/iconfont.css'
// 引入全部样式
import '@/style/index.less'

import 'viewerjs/dist/viewer.css'
import i18n from '@/i18n'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

Vue.config.productionTip = false

Vue.use(Viewer)
Vue.use(SvgIcon)
Vue.use(Directives)
Vue.use(vClickOutside)
Vue.use(Antd)

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
